/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Return_Section_ProductsInputs */

const vi_confirm_return_section_products = /** @type {(inputs: Confirm_Return_Section_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sản phẩm đã trừ kho`)
};

/**

* @param {Confirm_Return_Section_ProductsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const confirm_return_section_products = /** @type {((inputs?: Confirm_Return_Section_ProductsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Return_Section_ProductsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_confirm_return_section_products(inputs)
});